import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import __ from '../utils/translator';
import buttonMutedStyle from '../utils/buttonMutedStyle';
import ModalFullscreenActions from '../flux/ModalFullscreenActions';
import Header from './organisms/Header';
import RenderOnTablet from './responsive/RenderOnTablet';
import themeResponsiveProperty from './responsive/themeResponsiveProperty';

const MODAL_CLOSE_HEIGHT_REM = 3;

class FeedbackHelpContainer extends Component {
  render() {
    return (
      <Container>
        <Header
          actions={themeResponsiveProperty(['back'], [])(this.props)}
        />

        <ChildrenContainer>
          {this.props.children}
        </ChildrenContainer>

        <RenderOnTablet>
          <ModalClose onClick={ModalFullscreenActions.close} style={{ ...buttonMutedStyle, backgroundColor: '#323334', color: '#fff', }}>
            {__('Close')}
          </ModalClose>
        </RenderOnTablet>
      </Container>
    );
  }
}

export default withTheme(FeedbackHelpContainer);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ChildrenContainer = styled.div`
  flex: 1;
  display: inline;
`;

const ModalClose = styled.button`
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${MODAL_CLOSE_HEIGHT_REM}rem;
  color: #fff;
  font-size: 1rem;
`;
